import React from 'react';

import StatusCircle from 'components/StatusCircle';

import { Status } from 'types/base';

export const getStatusBadge = (item: Status): React.ReactElement => {
  if (item === 'active') {
    return <StatusCircle colorScheme="green">Ativo</StatusCircle>;
  }

  if (item === 'inactive') {
    return <StatusCircle colorScheme="gray">Inativo</StatusCircle>;
  }

  if (item === 'editing') {
    return <StatusCircle colorScheme="orange">Em edição</StatusCircle>;
  }

  if (item === 'processing') {
    return <StatusCircle colorScheme="blue">Processando</StatusCircle>;
  }

  return <StatusCircle colorScheme="gray">Outro</StatusCircle>;
};
